import { Profile } from '@news-mono/web-common'
import React from 'react'
import {
    StyledBylineFooter,
    StyledBylineHeading,
    StyledBylineSubHeading,
    StyledBylineWrapper,
    StyledBylineHeadingLink,
} from './Byline.styled'
import { getProfileLink } from '../../helpers/getProfileLink'
import { Bullet } from '../../../../cards/TheNightly/components'
import { Timestamp } from '../../../../typography/Timestamp/Timestamp'

type BylineTextProps = {
    profile: Profile[] | undefined
    source: string | undefined
    timestamp?: string | undefined
    text: string | undefined
    isContentPartner: boolean
    topic?: string
    readTimeMinutes?: number
    isLink?: boolean
}
export const BylineText: React.FC<BylineTextProps> = ({
    profile,
    source,
    timestamp,
    text,
    isContentPartner,
    topic,
    readTimeMinutes,
    isLink,
}) => {
    const profileLink = profile && getProfileLink(profile)

    /**                   ↓----Byline Text----↓
     *  |~~~~~~~~~~~|~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~|~~~~~~~~~~~~~~~|
     *  | profile   |   Top Row // Name             |               |
     *  | pic       |~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~| Container     |
     *  |           |   Middle Row // Publisher     |               |
     *  |___________|~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~| Container     |
     *              |   Bottom Row // Min read/Date |               |
     *              |~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~|_______________|
     */

    return (
        <StyledBylineWrapper>
            {/* Use a clickable link if one exists for the profile */}
            {profileLink && isLink ? (
                <StyledBylineHeadingLink to={profileLink}>
                    {text}
                </StyledBylineHeadingLink>
            ) : (
                <StyledBylineHeading>{text}</StyledBylineHeading>
            )}
            {source && (
                <StyledBylineSubHeading>
                    {source}
                    {isContentPartner && (
                        <StyledBylineFooter>
                            &nbsp;/ CONTENT PARTNER
                        </StyledBylineFooter>
                    )}
                </StyledBylineSubHeading>
            )}
            <StyledBylineFooter>
                {topic}
                {readTimeMinutes !== undefined && (
                    <span>{Math.floor(readTimeMinutes ?? 0) + 1} Min Read</span>
                )}
                {(readTimeMinutes || topic) && timestamp && <Bullet />}
                {timestamp && (
                    <Timestamp
                        iconVisible={true}
                        timestamp={timestamp}
                        timestampFormat={'dayMonthYear'} //Todo: tokenize?
                        timestampLabel={''}
                    />
                )}
            </StyledBylineFooter>
        </StyledBylineWrapper>
    )
}
